import { SxProps } from "@mui/material";
import { CSSProperties } from "react";

export const editButtons = {
  width: "94px",
  borderRadius: "5px",
};

export const editDialog = {
  borderRadius: "18px",
  maxWidth: "528px",
  display: "flex",
  flexGrow: 1,
};
export const editDialogContent: SxProps = {
  pl: "32px",
  pr: "22px",
  flexDirection: "column",
};

export const confirmButton = {
  ...editButtons,
  width: "auto",
};

export const dropDownStyle: SxProps = {
  maxWidth: "288px",
  borderRadius: "4px",
};

export const dropDownOptions: CSSProperties = {
  maxHeight: 250,
  position: "fixed",
};

export const textStyle: SxProps = {
  fontFamily: "Roboto",
  fontWeight: 500,
  fontSize: "14px",
  mt: "12px ",
  mb: "8px ",
};

export const titleStyle: SxProps = {
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "20px",
  mb: "4px",
  mt: "25px",
};
